export const isMobileApp = () =>
  (window.navigator.userAgent || '').toLowerCase().indexOf('hermes') !== -1;

export const isAndroidApp = () =>
  isMobileApp() && window.navigator.userAgent.match(/android/i) !== null;

export const isIosApp = () => isMobileApp() && !isAndroidApp();
